import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  const data = _taggedTemplateLiteral(["\n    display: inline-block;\n    padding: 0.5em 1em;\n    border-top: 2px solid lightblue;\n    background-color: #20242b;\n    border-radius: 3px;\n    position: relative;\n    top: 3px;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n    display: inline-block;\n    vertical-align: middle;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n    margin-right: 0.3em;\n    display: inline-block;\n    vertical-align: middle;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { getExtensionsIcon } from './extensions';
export const Tab = props => {
  const name = props.name;
  const icon = getExtensionsIcon(name);
  return React.createElement(Container, null, icon && React.createElement(Icon, {
    src: icon,
    width: 16,
    height: 16,
    alt: ""
  }), React.createElement(Name, null, name));
};
const Icon = styled.img(_templateObject());
const Name = styled.span(_templateObject2());
const Container = styled.div(_templateObject3());